import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/navigation/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/home/Home';
import Products from './pages/products/Products';
import ProductDetail from './pages/products/ProductDetail';
import Services from './pages/services/Services';
import Contact from './pages/contact/Contact';
import Pricing from './pages/pricing/Pricing';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Landing from './pages/landing/Landing';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navigation />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:productId" element={<ProductDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/lp" element={<Landing />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;

